export default __webpack_public_path__ + "static/Geek-c4261407cb1996e489e5e2eeb88a0d14.png";